module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    attrs: {
      "id": "devicelist"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAgentAdmin),
      expression: "isAgentAdmin"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-warning"
  }, [_c('div', {
    staticClass: "row data_aggregation_table_margin"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('table', {
    staticClass: "device-information-table"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "device-information-table-title table-width-quarter data_aggregation_title_color"
  }, [_vm._v("\n                    online device\n                  ")]), _vm._v(" "), _c('th', {
    staticClass: "device-information-table-content table-width-quarter data_aggregation_title_color"
  }, [_vm._v("\n                    " + _vm._s(_vm.onlineDevice) + "\n                  ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('table', {
    staticClass: "device-information-table"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "device-information-table-title table-width-quarter data_aggregation_title_color"
  }, [_vm._v("\n                    total device\n                  ")]), _vm._v(" "), _c('th', {
    staticClass: "device-information-table-content table-width-quarter data_aggregation_title_color"
  }, [_vm._v("\n                    " + _vm._s(_vm.totalDevice) + "\n                  ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row data_aggregation_table_margin"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('table', {
    staticClass: "device-information-table"
  }, [_c('tbody', [_vm._m(0), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "device-information-table-title table-width-quarter"
  }, [_vm._v("\n                    api_as\n                  ")]), _vm._v(" "), _c('td', {
    staticClass: "device-information-table-content table-width-quarter"
  }, [_vm._v("\n                    " + _vm._s(_vm.as) + "\n                  ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "device-information-table-title table-width-quarter"
  }, [_vm._v("\n                    api_eu\n                  ")]), _vm._v(" "), _c('td', {
    staticClass: "device-information-table-content table-width-quarter"
  }, [_vm._v("\n                    " + _vm._s(_vm.eu) + "\n                  ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "device-information-table-title table-width-quarter"
  }, [_vm._v("\n                    api_us\n                  ")]), _vm._v(" "), _c('td', {
    staticClass: "device-information-table-content table-width-quarter"
  }, [_vm._v("\n                    " + _vm._s(_vm.us) + "\n                  ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('table', {
    staticClass: "device-information-table"
  }, [_c('tbody', [_vm._m(1), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "device-information-table-title table-width-quarter"
  }, [_vm._v("\n                    normal\n                  ")]), _vm._v(" "), _c('td', {
    staticClass: "device-information-table-content table-width-quarter"
  }, [_vm._v("\n                    " + _vm._s(_vm.normalsim) + "\n                  ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "device-information-table-title table-width-quarter"
  }, [_vm._v("\n                    have no card\n                  ")]), _vm._v(" "), _c('td', {
    staticClass: "device-information-table-content table-width-quarter"
  }, [_vm._v("\n                    " + _vm._s(_vm.noCard) + "\n                  ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "device-information-table-title table-width-quarter"
  }, [_vm._v("\n                    with problem\n                  ")]), _vm._v(" "), _c('td', {
    staticClass: "device-information-table-content table-width-quarter"
  }, [_vm._v("\n                    " + _vm._s(_vm.problem) + "\n                  ")])])])])])]), _vm._v(" "), _c('br')])])]), _vm._v(" "), _vm._l((_vm.devicelist), function(item) {
    return _c('div', {
      staticClass: "box box-default device-list-box"
    }, [_c('router-link', {
      staticClass: "device-list-hover",
      attrs: {
        "to": {
          path: '/aboutdevice?appname=' +
            _vm.$route.query.appname +
            '&appid=' +
            _vm.$route.query.appid +
            '&devicename=' +
            encodeURIComponent(item.devicename) +
            '&deviceid=' +
            item.deviceid +
            '&online=' +
            item.online +
            '&t=' +
            item.devicetoken
        }
      }
    }, [_c('div', {
      staticClass: "box-header with-border"
    }, [_c('h3', {
      staticClass: "box-title device-list-name"
    }, [_vm._v(_vm._s(item.devicename))]), _vm._v(" "), _c('span', {
      staticClass: "agent-list-id device-list-id"
    }, [_vm._v("( "), _c('span', [_vm._v(_vm._s(item.deviceid))]), _vm._v(" )\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "pull-right device-list-go-to"
    }, [_c('span', [_vm._v("More  \n            "), _c('i', {
      staticClass: "fa fa-ellipsis-v"
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "box-body"
    }, [_c('table', {
      staticClass: "device-list-table"
    }, [_c('tr', {
      staticClass: "device-list-row"
    }, [_c('td', {
      staticClass: "col-xs-4"
    }, [_c('span', {
      staticClass: "device-list-table-content"
    }, [_vm._v("country/region: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.ipaddress))])]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-4 device-list-middle"
    }, [_c('span', {
      staticClass: "device-list-table-content"
    }, [_vm._v("network status: ")]), _vm._v(" "), (item.online != 1) ? _c('span', [_vm._v(" -")]) : (item.network / 1000000 < 200) ? _c('span', {
      staticClass: "device-network-status-excellent"
    }, [_vm._v("excellent \n                "), _c('i', {
      staticClass: "fa fa-thumbs-o-up"
    })]) : (item.network / 1000000 < 400) ? _c('span', {
      staticClass: "device-network-status-good"
    }, [_vm._v("good \n                "), _c('i', {
      staticClass: "fa fa-hand-peace-o"
    })]) : _c('span', {
      staticClass: "device-network-status-poor"
    }, [_vm._v("poor \n                "), _c('i', {
      staticClass: "fa fa-thumbs-o-down"
    })])]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-4 device-list-right"
    }, [(item.online == 1) ? _c('span', {
      staticClass: "device-list-table-content device-online-status"
    }, [_c('i', {
      staticClass: "fa fa-check-circle"
    }), _vm._v(" online\n              ")]) : _c('span', {
      staticClass: "device-list-table-content device-offline-status"
    }, [_c('i', {
      staticClass: "fa fa-times-circle"
    }), _vm._v(" offline\n              ")])])]), _vm._v(" "), _c('tr', {
      staticClass: "device-list-row"
    }, [_c('td', {
      staticClass: "col-xs-4"
    }, [_c('span', {
      staticClass: "device-list-table-content"
    }, [_vm._v("firmware version: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.version))])]), _vm._v(" "), (item.activetime > 0) ? _c('td', {
      staticClass: "col-xs-4 device-list-middle"
    }, [_c('span', {
      staticClass: "device-list-table-content"
    }, [_vm._v("activation time: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatDate")((item.activetime / 1000000))))])]) : _c('td', {
      staticClass: "col-xs-4 device-list-middle"
    }, [_c('span', {
      staticClass: "device-list-table-content"
    }, [_vm._v("activation time: ")]), _vm._v(" "), _c('span', [_vm._v(" -")])]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      staticClass: "col-xs-4 device-list-right"
    }, [_c('span', {
      staticClass: "device-list-table-content"
    }, [_vm._v("production batch: ")]), _vm._v(" "), _c('span', [_vm._v("1862443")])])])])])])], 1)
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "device-information-table-title table-width-quarter"
  }, [_vm._v("\n                    server\n                  ")]), _vm._v(" "), _c('th', {
    staticClass: "device-information-table-content table-width-quarter"
  }, [_vm._v("\n                    number of device\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "device-information-table-title table-width-quarter"
  }, [_vm._v("\n                    sim card status\n                  ")]), _vm._v(" "), _c('th', {
    staticClass: "device-information-table-content table-width-quarter"
  }, [_vm._v("\n                    number of device\n                  ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-529b6adc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-529b6adc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Device.vue
// module id = 470
// module chunks = 1